import React from 'react';
import { motion } from 'framer-motion';
import { Map, Settings, Rocket } from 'lucide-react';
const steps = [{
  num: '01',
  title: 'Map Workflows',
  description: 'We analyse your operational processes, compliance rules, and integration points.',
  icon: Map
}, {
  num: '02',
  title: 'Configure Agents',
  description: 'Purpose-built agents are configured around your specific industry logic.',
  icon: Settings
}, {
  num: '03',
  title: 'Deploy + Optimise',
  description: 'Go live with monitoring, human oversight, and continuous improvement.',
  icon: Rocket
}];
export function DeploymentSection() {
  return <section className="py-32 bg-[#050505] relative z-10" data-id="element-261">
      <div className="max-w-7xl mx-auto px-6" data-id="element-262">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-24" data-id="element-263">
          <h2 className="font-display text-4xl md:text-5xl text-white mb-6 tracking-tight" data-id="element-264">
            From Concept to Production,{' '}
            <span className="text-gray-500" data-id="element-265">Fast.</span>
          </h2>
        </motion.div>

        <div className="relative max-w-5xl mx-auto" data-id="element-266">
          {/* Horizontal connecting line (desktop) */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-px bg-white/10" data-id="element-267" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-268">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="flex flex-col items-center text-center group" data-id="element-269">
                <div className="w-24 h-24 rounded-full bg-[#0A0A0A] border border-white/10 flex items-center justify-center mb-8 relative transition-all duration-500 group-hover:border-brand-orange/30 group-hover:shadow-[0_0_30px_rgba(219,127,74,0.15)]" data-id="element-270">
                  <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-[#111] border border-white/10 flex items-center justify-center text-xs font-display text-brand-orange" data-id="element-271">
                    {step.num}
                  </div>
                  <step.icon className="w-8 h-8 text-gray-500 group-hover:text-white transition-colors duration-500" data-id="element-272" />
                </div>

                <h3 className="text-xl font-medium text-white mb-4 tracking-tight" data-id="element-273">
                  {step.title}
                </h3>
                <p className="text-gray-400 leading-relaxed text-sm max-w-[250px]" data-id="element-274">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}